
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noticias-flash/[slug]",
      function () {
        return require("private-next-pages/noticias-flash/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noticias-flash/[slug]"])
      });
    }
  